import React from 'react';
import { getSafeClientIssueMessage, reportClientIssue } from '../utils/clientIssueReporter';

/**
 * ErrorBoundary catches unhandled React rendering errors and shows a safe UI
 * instead of crashing the entire application.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    reportClientIssue(error, {
      source: 'react_error_boundary',
      action: 'render_failure',
      componentStack: errorInfo?.componentStack || '',
    }, {
      severity: 'high',
      force: true,
    });

    if (process.env.NODE_ENV === 'development') {
      // eslint-disable-next-line no-console
      console.error('ErrorBoundary caught:', error, errorInfo);
    }
  }

  handleReload = () => {
    this.setState({ hasError: false });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: '60vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '40px 20px',
          textAlign: 'center',
        }}>
          <div style={{
            width: 52,
            height: 52,
            borderRadius: 16,
            display: 'grid',
            placeItems: 'center',
            marginBottom: 16,
            background: '#fff4e5',
            color: '#b45309',
            fontSize: 28,
            fontWeight: 900,
          }}>
            !
          </div>
          <h2 style={{ color: '#1F1144', marginBottom: '8px' }}>Something went wrong</h2>
          <p style={{ color: '#6B7280', marginBottom: '24px', maxWidth: '440px' }}>
            {getSafeClientIssueMessage()}
          </p>
          <button
            onClick={this.handleReload}
            style={{
              padding: '10px 24px',
              background: '#A259FF',
              color: '#fff',
              border: 'none',
              borderRadius: '8px',
              fontSize: '14px',
              fontWeight: '600',
              cursor: 'pointer',
            }}
          >
            Reload Page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}
